export default {
    scale: {
        low: 'low',
        moderate: 'moderate',
        high: 'high',
        veryHigh: 'very high'
    }
}
